import React from "react"

const GoogleMap = () => {
  return (
    <div className="my-10 container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d453.03755608915804!2d72.67750859838746!3d23.064567637928214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e86e3aa03be47%3A0x725df12e51a9e450!2sSrashtaSoft!5e0!3m2!1sen!2sin!4v1757334431601!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  )
}

export default GoogleMap
